import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Grid,
} from "@mui/material";
import farmerImage from "../../assets/landing/images/standing-farmer.png";
import kisanpatilLogo from "../../assets/landing/images/kisan_patil.png";
import { useTranslation } from "react-i18next";

import {CheckCircleOutline as CheckCircleOutlineIcon, ChatBubbleOutline as ChatBubbleOutlineIcon, Image as ImageIcon, Check as CheckIcon, BarChart as BarChartIcon} from "@mui/icons-material";  


const FeatureDisplay = () => {
  const { t } = useTranslation();
  const features = [
    t("AI-Powered Precision Farming"),
    t("Seamless Farm Mapping & Digital Records"),
    t("Market-Ready Procurement & Trade Solutions"),
    t("Data-Driven Soil Health & Sustainability"),
    t("Automated Alerts & Advisory Services"),
  ];

  return (
    <Box
      sx={{
        my: 16,
      }}
    >
      <Grid
        spacing={2}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        {/* Left Section */}
        <Grid>
          <Box sx={{ mt: 4 }}>
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontWeight: "bold",
                color: "#222",
                fontSize: { xs: "2.5rem", md: "3.5rem" },
              }}
            >
              {t("Why Choose")}
              <br />
              {t("FarmApp?")}
            </Typography>
          </Box>

          <List>
            {features.map((feature, index) => (
              <ListItem key={index} sx={{ mb: 2 }}>
                <ListItemIcon>
                  <CheckIcon
                    sx={{
                      color: "#FFFFFF",
                      fontSize: 30,
                      backgroundColor: "#54BD95",
                      borderRadius: "50%",
                      p: 0.5,
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={feature}
                  primaryTypographyProps={{
                    fontWeight: "medium",
                    fontSize: "1.2rem",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Grid>

        {/* Right Section */}
        <Grid>
          <Box
            sx={{
              position: "relative",
              height: "100%",
            }}
          >
            {/* Background image */}
            <Box
              component="img"
              src={farmerImage}
              alt="Farmer in field"
              sx={{
                width: "429px",
                height: "529px",
                objectFit: "cover",
                borderRadius: 2,
                boxShadow: 3,
              }}
            />

            {/* User Message Card */}
            <Card
              sx={{
                position: "absolute",
                top: "36px",
                left: "-124px",
                width: "304px",
                height: "82px",
                maxWidth: 320,
                borderRadius: 2,
                boxShadow: 2,
              }}
            >
              <CardContent sx={{ display: "flex", p: 2 }}>
                <Avatar
                  src={kisanpatilLogo}
                  alt="Kisan Patil"
                  sx={{ width: 56, height: 56 }}
                />
                <Box sx={{ ml: 2 }}>
                  <Typography variant="h6" component="div">
                    {t("Kisan Patil")}
                  </Typography>
                  <Typography sx={{ color: "grey.500", fontSize: "12px" }}>
                    {t("Best app for Farmer")}
                  </Typography>
                </Box>
                <Box sx={{ ml: "auto" }}>
                  <Avatar sx={{ bgcolor: "#74C9A9" }}>
                    <ChatBubbleOutlineIcon />
                  </Avatar>
                </Box>
              </CardContent>
            </Card>

            {/* Income Card */}
            <Paper
              sx={{
                position: "absolute",
                top: "121px",
                right: "-70px",
                width: "120px",
                height: "50px",
                borderRadius: 2,
                boxShadow: 2,
                p: "12px",
              }}
            >
              <Typography sx={{ color: "grey.500", fontSize: "12px" }}>
                {t("Total Income")}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ fontWeight: "bold" }}>₹5245.00</Typography>
                <BarChartIcon sx={{ color: "#74C9A9", paddingLeft: "10px" }} />
              </Box>
            </Paper>

            {/* Image Icon */}
            <Avatar
              sx={{
                position: "absolute",
                top: "285px",
                left: "-50px",
                transform: "rotate(-15deg)",
                bgcolor: "#74C9A9",
                width: "40px",
                height: "40px",
                boxShadow: 2,
              }}
            >
              <ImageIcon sx={{ color: "white", fontSize: 32 }} />
            </Avatar>

            {/* Success Notification */}
            <Card
              sx={{
                position: "absolute",
                bottom: "5px",
                left: "-110px",
                boxShadow: 2,
                display: "flex",
                alignItems: "center",
                p: 2,
              }}
            >
              <CheckCircleOutlineIcon sx={{ color: "#2B9B5B", fontSize: 32 }} />
              <Typography>{t("Your Farm added Successfully")}</Typography>
            </Card>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FeatureDisplay;
